import React from 'react';

import { Tooltip } from '@vlabs/uikit';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import st from './shared.module.sass';
import type { EstimationStatusProps } from './types';

export function EstimationStatus({ icon, status, estimationType }: EstimationStatusProps): React.JSX.Element {
  const iconNode = React.cloneElement(icon, { className: cn(st.Icon, icon.props.className) });
  const { t } = useTranslation();
  return (
    <Tooltip
      tooltipContent={t(`checks:estimations.${estimationType}.title`)}
      tooltipProps={{ place: 'bottom' }}
    >
      <div
        className={cn(st.IconWrapper, st[`Status_${status}`])}
      >
        {iconNode}
      </div>
    </Tooltip>

  );
}
